export interface ReadinessInputs {
  hasLocation: boolean;
  parcelConfirmed: boolean;
  goalsDefined: boolean;
  photosAttached: boolean;
  budgetSelected: boolean;
  timelineSelected: boolean;
  partnerPermission: boolean;
}

export function calculateBriefReadiness(input: ReadinessInputs): number {
  const weights: Record<keyof ReadinessInputs, number> = {
    hasLocation: 20,
    parcelConfirmed: 20,
    goalsDefined: 20,
    photosAttached: 10,
    budgetSelected: 10,
    timelineSelected: 10,
    partnerPermission: 10
  };

  return (Object.keys(weights) as Array<keyof ReadinessInputs>).reduce(
    (score, key) => score + (input[key] ? weights[key] : 0),
    0
  );
}

export function leadFitLabel(score: number): 'Strong fit' | 'Review fit' | 'Early inquiry' {
  if (score >= 80) return 'Strong fit';
  if (score >= 55) return 'Review fit';
  return 'Early inquiry';
}
